import { Alert, Box, CloseButton, FormField, Heading, Label, Select } from '@zillow/constellation-10';
import { HomeType } from '@zg-rentals/ts-capps-client';
import { useEffect, useRef, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FIELD_IDS } from '../../../../constants/wizard';
import { US_STATES_ABBR_LIST_EXCLUDING_TERRITORIES } from '../../../../constants/applicationsConstants';
import { CurrentAddress } from './1CurrentResidenceStep';

export function GuarantorCurrentResidenceStep() {
  const {
    formState: { submitCount },
    setValue,
    trigger,
    watch,
  } = useFormContext();
  const homeType = watch(FIELD_IDS.CURRENT_RESIDENCE_TYPE);
  const stateValue = watch(FIELD_IDS.CURRENT_RESIDENCE_STATE);
  const zpid = watch(FIELD_IDS.CURRENT_RESIDENCE_ZPID);
  const [isZipOutsideUsStates, setIsZipOutsideUsStates] = useState(false);
  const [isTerritoryNoticeDismissed, setIsTerritoryNoticeDismissed] = useState(false);
  const submitCountOnMount = useRef(submitCount);
  const isStateOutsideUsStates =
    !!stateValue && !US_STATES_ABBR_LIST_EXCLUDING_TERRITORIES.includes(stateValue.toUpperCase());
  const showTerritoryNotice =
    (isStateOutsideUsStates || isZipOutsideUsStates) &&
    submitCount > submitCountOnMount.current &&
    !isTerritoryNoticeDismissed;

  useEffect(() => {
    if (!homeType) {
      setValue(FIELD_IDS.CURRENT_RESIDENCE_TYPE, HomeType.RENT);
      trigger(FIELD_IDS.CURRENT_RESIDENCE_TYPE);
    }
  }, [homeType, setValue, trigger]);

  useEffect(() => {
    setIsTerritoryNoticeDismissed(false);
  }, [zpid, submitCount]);

  return (
    <>
      <Heading level={2} textStyle="heading-sm" css={{ marginBottom: 'sm' }}>
        Current residence
      </Heading>
      {showTerritoryNotice && (
        <Alert
          tone="warning"
          role="alert"
          closeButton={<CloseButton onClick={() => setIsTerritoryNoticeDismissed(true)} />}
          css={{ marginBottom: 'sm' }}
        >
          We’re unable to process applications from outside the United States. Enter an address in one of the 50 states
          or Washington, D.C. to continue.
        </Alert>
      )}
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'sm' }}>
        <Controller
          name={FIELD_IDS.CURRENT_RESIDENCE_TYPE}
          render={({ field }) => (
            <FormField
              label={<Label>Type</Label>}
              control={
                <Select {...field} value={field.value || ''}>
                  <option value={HomeType.RENT}>A home I rent</option>
                  <option value={HomeType.OWN}>A home I own</option>
                  <option value={HomeType.OTHER}>A different type of home</option>
                </Select>
              }
            />
          )}
        />
        <CurrentAddress onZipTerritoryChange={setIsZipOutsideUsStates} />
      </Box>
    </>
  );
}
